import { OccConfig } from '@spartacus/core';

export enum DELIVERY_COST_OCC {
  SEARCH = 'search',
}

export const OccDeliveryCost: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        [DELIVERY_COST_OCC.SEARCH]: '/xxx',
      } as any,
    },
  },
};
